import React, { useCallback, useEffect } from 'react';
import { Container } from '@mui/material';
import { useParams, useSearchParams } from 'react-router-dom';
import { getAuditionsDetails } from '../../redux/audition/actions';
import { useDispatch } from 'react-redux';
import { AuditionContainer } from '../../components/ScreenContainer/AuditionContainer/AuditionContainer';
import { useSelector } from 'react-redux';
import { gettingAuditionSelector, selectedAuditionSelector, similarAuditionsSelector } from './selector';
import { MetaTags } from '../../components/Metatags/Metatags';
import { EmptySearchBlock } from '../../components/EsSidebar/EsSearch/EmptySearchBlock';
import { Loading } from '../../components/Loading/Loading';
import { navigate } from '../../redux/navigator/action';

const AuditionDetails = () => {
    const params = useParams();
    const [searchParams] = useSearchParams();
    const audition = useSelector(selectedAuditionSelector);
    const loading = useSelector(gettingAuditionSelector);
    const similarAuditions = useSelector(similarAuditionsSelector);
    const query = Object.fromEntries([...searchParams]);
    const dispatch = useDispatch();
    const { auditionId } = params;

    const handleGetAudition = useCallback(() => {
        if (auditionId) {
            dispatch(
                getAuditionsDetails({
                    auditionSlug: auditionId,
                    params: !!query && query.search ? '?search=true' : '',
                }),
            );
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [auditionId]);

    useEffect(() => {
        handleGetAudition();
    }, [handleGetAudition]);

    if (!loading && !audition) {
        return (
            <MetaTags title={`Job`} description={'Job not found'}>
                <Container sx={{ justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
                    <EmptySearchBlock title="Job not found" subTitle="Please check the title" />
                </Container>
            </MetaTags>
        );
    }

    return (
        <MetaTags title={`Audition | ${audition?.title!}`} description={audition?.synopsis!}>
            <Container maxWidth={false} disableGutters sx={{ px: 0 }}>
                {loading && <Loading />}
                {audition && (
                    <AuditionContainer
                        audition={audition}
                        similarAuditions={similarAuditions}
                        hideDetails
                        onBackButtonPressed={() => dispatch(navigate({ routes: -1, skipAuthentication: true }))}
                    />
                )}
            </Container>
        </MetaTags>
    );
};

export { AuditionDetails };
